import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { Base64 } from 'js-base64';
import Typography from '../../../../components/shared/Typography/Typography.component';
import CloseIcon from '@material-ui/icons/Close';
import I18n from '../../../../components/shared/i18n/I18n.component';
import ButtonV2 from '../../../../components/shared/Buttons/ButtonV2.container';
import colors from '../../../../config/colors';
import moment from 'moment';

export type PermissionSelection = 'ADD' | 'REMOVE';

/**
 * A single permission row: the permission name on the right and, on the left, two
 * pill buttons - add / remove. The row is fully controlled by the parent's
 * `checkedRoles`; pressing the already-selected pill deselects it (onChange(null)).
 */
export const PermissionRow = ({
	data,
	value,
	onChange,
}: {
	data: any;
	value?: PermissionSelection;
	onChange: (val: PermissionSelection | null) => void;
}) => {
	const onPressSegment = (segment: PermissionSelection) => {
		onChange(value === segment ? null : segment);
	};

	return (
		<View style={styles.rowContainer}>
			<View style={styles.segmentedControl}>
				<TouchableOpacity
					onPress={() => onPressSegment('ADD')}
					style={[
						styles.segment,
						value === 'ADD' && styles.segmentSelected,
					]}
				>
					<I18n
						size={14}
						weight='normal'
						color={value === 'ADD' ? 'white' : 'primaryDarkBlue'}
					>
						updateUserermisions.add
					</I18n>
				</TouchableOpacity>

				<TouchableOpacity
					onPress={() => onPressSegment('REMOVE')}
					style={[
						styles.segment,
						value === 'REMOVE' && styles.segmentSelected,
					]}
				>
					<I18n
						size={14}
						weight='normal'
						color={value === 'REMOVE' ? 'white' : 'primaryDarkBlue'}
					>
						updateUserermisions.remove
					</I18n>
				</TouchableOpacity>
			</View>

			<Typography color='primaryDarkBlue' size={14} weight='normal'>
				{data.name}
			</Typography>
		</View>
	);
};

export const NotificationModal = ({ onAccept, onNext }: any) => {
	return (
		<View style={styles.sendNewRequestContainer}>
			<View style={styles.header}>
				<I18n color='primaryDarkBlue' font='medium' size={18}>updateUserermisions.title</I18n>

				<TouchableOpacity onPress={() => onNext()}>
					<CloseIcon style={{ fontSize: 20, color: colors.greyText }} />
				</TouchableOpacity>

			</View>
			<View style={styles.sendNewRequestText}>
				<I18n color='clockRecordBlue'>updateUserermisions.areYouWantToUpdate</I18n>
			</View>

			<View style={styles.buttonContainer}>
				<ButtonV2 preset='primary' onPress={() => onAccept(onNext)}>
					<I18n size={16} weight='normal' color='white'>
						general.accept
					</I18n>
				</ButtonV2>

				<ButtonV2 preset='outline' onPress={() => onNext()}>
					<I18n size={16} weight='normal' color='titlePrimary'>
						general.cancel
					</I18n>
				</ButtonV2>
			</View>
		</View>
	);
};

export const onDownload = async (data) => {
	let elm = document.createElement('a');
	const csvFile = Base64.decode(data);
	const universalBOM = '﻿';

	elm.href = 'data:attachment/csv,' + encodeURIComponent(universalBOM + csvFile);

	elm.setAttribute(
		'download',
		`UPDATE_USER_ROLE${moment().format('DD-MM-YYYY').replaceAll('-', '')}.csv`,
	);
	elm.click();
};

const styles = StyleSheet.create({
	rowContainer: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: 24,
	},
	segmentedControl: {
		flexDirection: 'row-reverse',
		alignItems: 'center',
		gap: 4,
		padding: 4,
		backgroundColor: colors.buttonContainerBG,
		borderRadius: 50,
	},
	segment: {
		minWidth: 64,
		height: 24,
		paddingVertical: 0,
		paddingHorizontal: 12,
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: 50,
		borderWidth: 1,
		borderColor: colors.white,
		backgroundColor: colors.white,
	},
	segmentSelected: {
		backgroundColor: colors.primary,
		//borderColor: colors.lightPrimary,
	},
	sendNewRequestContainer: {
		padding: 32,
		flexDirection: 'column',
		shadowColor: 'rgba(0, 0, 0, 0)',
		shadowOpacity: 0.1,
		shadowOffset: { width: 0, height: 2 },
		backgroundColor: colors.white,
		borderRadius: 20,
		height: 239,
		width: 420,
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	buttonContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		width: '100%',
		gap: 16,
	},
	sendNewRequestText: {
		marginBottom: 20,
	},
	header: {
		width: '100%',
		flexDirection: 'row-reverse',
		alignItems: 'center',
		justifyContent: 'space-between',
		flexShrink: 0,
	},
});
